import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-wrap">
        <div className="w-100 clearfix">
          <span className="d-block text-center text-sm-left d-sm-inline-block">
            ©{" "}
            <a href="https://cvalenciait.com" target="_blank" rel="noreferrer">
              cvalenciait.com
            </a>
          </span>
          <span className="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">
            Hand-crafted & made with <i className="mdi mdi-heart-outline"></i>
          </span>
        </div>
      </div>
    </footer>
  );
}

export { Footer };
